import {ResourceLoader} from '../utils/ResourceLoader'
import {Base} from './Base'
import {LatLon} from '../models/LatLon'
import {LeafletTileProviders} from '../utils/LeafletTileProvider'

export class Leaflet extends Base {
  public config: any

  public loadResources() {
    return [
      ResourceLoader('css', 'leaflet-map', 'https://unpkg.com/leaflet@1.6.0/dist/leaflet.css'),
      ResourceLoader('script', 'leaflet-map', 'https://unpkg.com/leaflet@1.6.0/dist/leaflet.js'),
    ]
  }

  public initMap(element: HTMLElement, initConfig: any, s: any): void {
    // @ts-ignore
    this.map = L.map(element).setView([initConfig.center.latitude, initConfig.center.longitude], initConfig.zoom).setMaxZoom(18)
    const provider = LeafletTileProviders(this.config.tiles)
    // @ts-ignore
    L.tileLayer(provider.url, provider.opt).addTo(this.map)

    // L.addVectorTile('http://localhost:8989/mvt/{z}/{x}/{y}.mvt').addTo(this.map)

 // https://github.com/Leaflet/Leaflet.VectorGrid
    //ResourceLoader('script', 'leaflet-map-vector', 'https://unpkg.com/leaflet.vectorgrid@latest/dist/Leaflet.VectorGrid.bundled.js').then(() => {
        //url: 'http://localhost:8989/mvt/{z}/{x}/{y}.mvt'
      //let l = VectorTileLayer('http://localhost:8989/mvt/{z}/{x}/{y}.mvt')
      //l = VectorTileLayer('https://{s}.tiles-api.maps.komoot.net/v1/tiles/poi/{z}/{x}/{y}.vector.pbf')
      //l = VectorTileLayer('https://api.mapbox.com/v4/mapbox.mapbox-streets-v8,mapbox.mapbox-terrain-v2/{z}/{x}/{y}.vector.pbf?sku=101PIdFjDdrM9&access_token=pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY2p0MG01MXRqMW45cjQzb2R6b2ptc3J4MSJ9.zA2W0IkI0c6KaAhJfk9bWg', {
      //  minDetailZoom: 1,
      //  maxDetailZoom: 13,
      // https://api.mapbox.com/v4/mapbox.mapbox-streets-v8,mapbox.mapbox-terrain-v2/{z}/{x}/{y}.vector.pbf?sku=101PIdFjDdrM9&access_token=pk.eyJ1IjoiZXhhbXBsZXMiLCJhIjoiY2p0MG01MXRqMW45cjQzb2R6b2ptc3J4MSJ9.zA2W0IkI0c6KaAhJfk9bWg
      //})
      //let l = L.vectorGrid.protobuf('http://localhost:8989/mvt/{z}/{x}/{y}.mvt')
      //this.map.addLayer(l)
    //})

    s()
  }

  public setClickListener(l: (p: LatLon) => void): void {
    this.map.on('click', (ev: any) => {
      l(new LatLon(ev.latlng.lat, ev.latlng.lng))
    })
  }

  public pan(p: LatLon): void {
    // map.flyTo([lat, lng], zoom);
    this.map.flyTo([p.latitude, p.longitude])
  }

  public destroy(): void {
    this.map.off()
    this.map.remove()
    delete this.map
  }

  public cleanChild(c: any): void {
    this.map.removeLayer(c)
  }

  public addPolyline(points: LatLon[], lineWidth: number, color2: string): void {
    // @ts-ignore
    return L.polyline(points.map((p: LatLon) => {
      return [p.latitude, p.longitude]
    }), {
      weight: lineWidth,
      color: color2,
    }).addTo(this.map)
  }

  // openPopup: item.openPopup()
  public addMarker(point: LatLon, icon: string, popupElement: any, click: () => void): void {

    let markerOptions: any = {}

    if (icon) {
      // @ts-ignore
      markerOptions.icon = L.icon({
        iconUrl: icon,
        iconAnchor: [15, 15], // Half the size to center
        iconSize: [30, 30],
      })
    }

    // @ts-ignore
    const i = L.marker([point.latitude, point.longitude], markerOptions)

    // Infobox detection
    if (popupElement) {
      i.bindPopup(popupElement)
    }
    // Click detection
    if (click) {
      i.on('click', () => {
        click()
      })
    }
    // https://github.com/Leaflet/Leaflet.markercluster/issues/346#issuecomment-41742441
    // Maybe is best to not add the marker if not in root?
    if (this.map) {
      i.addTo(this.map)
    }

    return i
  }

  public addCircle(point: LatLon, radius: number, popupElement: any, click: () => void) {
    // @ts-ignore
    let i = L.circle([point.latitude, point.longitude], {
      radius: radius
    })
    if (this.map) {
      i.addTo(this.map)
    }

    if (click) {
      i.on('click', () => {
        click()
      })
    }

    if (popupElement) {
      i.bindPopup(popupElement)
    }

    return i
  }


  public markerClusterLib(): any[] {
    const u = 'https://unpkg.com/@google/markerclustererplus@4.0.1/dist/markerclustererplus.min.js'
    return [
      ResourceLoader('css', 'leaflet-map-marker-clusterer', 'https://unpkg.com/leaflet.markercluster@1.4.1/dist/MarkerCluster.css'),
      ResourceLoader('css', 'leaflet-map-marker-clusterer-def', 'https://unpkg.com/leaflet.markercluster@1.4.1/dist/MarkerCluster.Default.css'),
      ResourceLoader('script', 'leaflet-map-marker-clusterer', 'https://unpkg.com/leaflet.markercluster@1.4.1/dist/leaflet.markercluster.js'),
    ]
  }

  // https://github.com/Leaflet/Leaflet.markercluster
  public markerCluster(item: any, child: any): void {
    // Bypass reactivity edge-case
    // @ts-ignore
    if (typeof L === 'undefined') {
      return
    }

    // Sanity check for double init problem: first markers will never be removed
    if (item) {
      item.clearLayers()
      //this.map.removeLayer(item)
    }
    // @ts-ignore
    let i = L.markerClusterGroup()
    child.forEach((childrenMarker: any) => {
      // Remove from map https://github.com/Leaflet/Leaflet.markercluster/issues/346#issuecomment-41742441
      // Hotfix, should be better to not add the marker in first place
      this.cleanChild(childrenMarker.item)
      i.addLayer(childrenMarker.item)
    })
    this.map.addLayer(i)
    return i
  }


  public addPolygon(points: LatLon[], lineWidth: number, color: string, popupElement: any, click: () => void): void {
    // @ts-ignore
    let i = L.polygon(points.map((p: LatLon) => {
      return [p.latitude, p.longitude]
    }), {
      weight: lineWidth,
      color: color,
    }).addTo(this.map)

    if (click) {
      i.on('click', () => {
        click()
      })
    }

    if (popupElement) {
      i.bindPopup(popupElement)
    }

    return i
  }


  public addHeatmap(points: LatLon[]): void {
    Promise.all([
      ResourceLoader('script', 'leaflet-map-heat.js', 'https://www.unpkg.com/leaflet.heat@0.2.0/dist/leaflet-heat.js'),
    ]).then(() => {
      // @ts-ignore
      L.heatLayer(points.map((p: LatLon) => {
        return [p.latitude, p.longitude, 1]
      }), {radius: 25}).addTo(this.map)
    })
  }

  // leaflet zoom to: map.fitBounds(polygon.getBounds());
}
